/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  CurveReentrancyCheck,
  CurveReentrancyCheckInterface,
} from "../CurveReentrancyCheck";

const _abi = [
  {
    inputs: [],
    name: "InvalidInterface",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPoolConfiguration",
    type: "error",
  },
  {
    inputs: [],
    name: "MissingPoolReentrancyConfig",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_gasLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "_nCoins",
        type: "uint8",
      },
    ],
    name: "ReentrancyCheckConfigUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "MIN_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "isLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolReentrancyConfig",
    outputs: [
      {
        internalType: "uint128",
        name: "gasLimit",
        type: "uint128",
      },
      {
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "nCoins",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_gasLimit",
        type: "uint128",
      },
      {
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "_nCoins",
        type: "uint8",
      },
    ],
    name: "setReentrancyVerificationConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class CurveReentrancyCheck__factory {
  static readonly abi = _abi;
  static createInterface(): CurveReentrancyCheckInterface {
    return new utils.Interface(_abi) as CurveReentrancyCheckInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveReentrancyCheck {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveReentrancyCheck;
  }
}
